import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FormMarketingDeskComponent } from '../form-marketing-desk/form-marketing-desk.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-register-srec-commercial',
  templateUrl: './register-srec-commercial.component.html',
  styleUrls: ['./register-srec-commercial.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FormMarketingDeskComponent,
    MatIconModule,
    MatButtonModule
  ]
})
export class RegisterSrecCommercialComponent implements OnInit {
  referralSource: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.referralSource = this.route.snapshot.queryParams['referralSource'] || '';
  }

  returnToRegisterSection() {
    this.router.navigate(['/register']);
  }
} 